export default {
    builders: {
        searchable: {
            create: 'Create ',
        },
        yearMonthPicker: {
            defaultSelect: 'Select a month',
        },

        localeDropdown: {
            languages: {
                en: 'English',
                cn: 'Chinese',
            },
        },
    },

    miscellaneous: {
        verifyModule: {
            title: 'Verify your school e-mail',
            description: `It's a quick process and will give you access to
                            exclusive features like unique job postings, skill
                            tests and career resources.`,

            verificationPending: 'Verification pending',
            weHaveSentAnEmail: ` We have sent an e-mail to
                                <strong>{studentEmail}</strong> for
                                you to verify yourself. Be sure to
                                check your spam folder, as many schools are
                                quite strict on incoming emails.`,
            verifyMe: 'Verify me',
            resendVerifyEmail: 'Resend verification email',
            cancelVerification: 'Cancel verification',

            emailSent: 'Email sent',
            emailSentMessage:
                'Email was successfully sent. If you do not receive it, contact us at support@highered.global.',

            resendErrorTitle: 'Error during resending email',
            resendErrorMessage:
                'Was not able to resend verification email. Please contact us at support@highered.global.',

            verificationCancelledTitle: 'Verification cancelled',
            verificationCancelledMessage: 'Verification was successfully cancelled.',

            cancelErrorTitle: 'Error during cancellation',
            cancelErrorMessage:
                'Was not able to cancel verification. Please contact us at support@highered.global.',
        },

        verifyModuleDialog: {
            title: 'Verify your school e-mail',
            university: 'Academic Institution',
            studentEmail: 'Your academic e-mail address',
            studentEmailPlaceholder: 'Academic email',
            verify: 'Verify',
            verificationInProcess: 'Verification in process',
            emailHasBeenSentTo:
                'An email has been sent to <strong>{email}</strong>. Follow the instructions there to verify your connection to <strong>{schoolName}</strong>',
            ifNoEmailRecieved: 'If you have not received the verification mail please contact us.',
            contactHelp: 'Contact us for help',
        },
    },

    navigation: {
        navigation: {
            myPage: 'My page',
            jobs: 'Jobs',
            companies: 'Companies',
            resources: 'Masterclasses',
            assessments: 'Assessments',
            countryGuides: 'Country Guides',
            goToHaigui: 'Jobs in China',
            signIn: 'Sign in',
            vfairs: 'EFMD Virtual Fair',

            newFeature: 'New Feature!',
        },

        profileNavigation: {
            signOut: 'Sign out',
        },

        sidebar: {
            myPage: 'My page',
            findJobs: 'Find jobs',
            findCompanies: 'Find companies',
            resources: 'Masterclasses',
            assessments: 'Assessments',
            countryGuides: 'Country Guides',
            goToHaigui: 'Jobs in China',
            virtualFairs: 'Virtual Career Fairs',

            signIn: 'Sign in',
            logOut: 'Log out',
        },
    },

    smart: {
        companyModule: {
            followJob: 'Add to favorites',
            followCompany: 'Follow company',
            unFollowJob: 'Remove from favorites',
            unFollowCompany: 'Unfollow company',

            favoritedTitle: 'Saved to favorites',
            favoritedMessage:
                'This position has been saved to your favorites. Find your favorite positions at my page.',
            unfavoritedTitle: 'Removed from favorites',
            unfavoritedMessage: 'This position has been removed from your favorites.',
            favoriteErrorTitle: 'Something went wrong',
            favoriteErrorMessage: 'Was not able to favorite this position',
        },
        profileModule: {
            profileCompletion: 'Profile completion',
            profileCompletionEncouragement:
                'Showcase yourself to employers by completing the last {percentageLeft} of your profile',
            gotoProfilePage: 'Update profile',
            profileCompleted: 'Profile completed',
            profileCompletedWhatsNext:
                'Did you know that most employers use online assessments in their recruiting processes? Practice now and get insights on your strengths and weaknesses.',
            gotoTestsPage: 'Go to assessment center',

            authIndication: {
                title: 'Find your dream job',
                description:
                    'Do you want access to positions that are unique to your school, and tests that will supercharge your job search? Easily create a user with Google, LinkedIn or Facebook today.',
                action: "Let's go",
            },

            toProfileHint: 'To my profile',

            profileActions: {
                addFirstName: 'Add first name',
                addLastName: 'Add last name',
                addNationality: 'Add nationality',
                addPhoneNumber: 'Add your phone number',
                addLanguage: 'Add a language',
                addEducation: 'Add an education',
                addEmail: 'Add your email',
                addGender: 'Add your gender',
            },
        },

        featuredCompanies: {
            label: 'Featured Companies',
        },

        featuredPositions: {
            label: 'Featured Positions',
        },

        featuredResource: {
            header: 'Join the Virtual Conference',
            cta: 'Watch now!',
            wechatSignupHeader: 'Join our WeChat group to stay updated',
            wechatSignupCta: 'Scan code to join now!',
        },
    },
};
